import React from 'react'
import Radium from 'radium'

const Header = ({ content, style, inputStyle }) => (
    <div style={[styles.header, style]}>
        <input type="text" readOnly value={content} style={[styles.input, inputStyle]} />
    </div>
);

const styles = {
    header: {
        flexGrow: 0,
        flexShrink: 0,
    },
    input: {
        border: 'none',
        outline: 'none',
        borderRadius: 0,
        '-webkit-box-shadow': 'none',
        '-moz-box-shadow': 'none',
        'box-shadow': 'none',
        fontWeight: 900,
        ':focus': {
            border: 'none',
            outline: 'none',
        }
    }
}

export default Radium(Header);


// WEBPACK FOOTER //
// ./src/App/APV/spreadsheets/table/header.js